import {
  HttpEvent,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private activeRequests = 0;

  constructor(private injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
    const spinner = this.injector.get(NgxSpinnerService);

    this.activeRequests += 1;
    if (this.activeRequests === 1) {
      setTimeout(() => spinner.show(), 0);
    }

    return next.handle(request).pipe(
      finalize(() => {
        this.activeRequests = Math.max(this.activeRequests - 1, 0);

        if (this.activeRequests === 0) {
          setTimeout(() => spinner.hide(), 0);
        }
      })
    );
  }
}
